

import React, { useState, useEffect, useRef } from "react";
import { Box, Button, TextField, Grid } from "@mui/material";
import Slider from "react-slick";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const slickCSS = `
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.slick-list:focus { outline: none; }
.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}
.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before,
.slick-track:after { display: table; content: ''; }
.slick-track:after { clear: both; }
.slick-loading .slick-track { visibility: hidden; }
.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
  transition: transform 0.4s ease, opacity 0.4s ease;
}
.slick-initialized .slick-slide { display: block; }
.slick-loading .slick-slide { visibility: hidden; }
.slick-arrow.slick-hidden { display: none; }

/* Side slides: scaled down by default */
.slick-slide img {
  transform: scale(0.88);
  opacity: 0.95;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

/* Center/active slide: full scale */
.slick-current img {
  transform: scale(1) !important;
  opacity: 1 !important;
}
`;

const backgroundImage =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2FScreenshot%202026-05-19%20at%2011.04.32%E2%80%AFPM.png?alt=media&token=aeb699f5-88f9-4c80-b8db-966268227f3b";

const car1 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fmgi-hector-model-car.png?alt=media&token=2a8c4677-56b2-46fd-963d-2041f6019fd0";
const car2 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fglostor-model-car.png?alt=media&token=4ea8a814-d952-4774-a3f0-dd9c993478d0";
const car3 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcmmet-model-car.png?alt=media&token=75fc8f35-0982-464f-aba3-010403c1af39";
const car4 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fastor-model-car.png?alt=media&token=d5d9eda2-58ce-4bd1-9ba1-ece743960948";
const car5 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fzs-img-car.png?alt=media&token=34b67158-0218-43c0-ab78-a4eed6aba5f9";
const car6 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcuv-img.png?alt=media&token=97665ca0-7a1a-442d-8ba4-18430afccdde";
const car7 = "https://www.mgmotor.co.in/content/dam/mgmotor/images/mj-img-dsc-001.png";
const car8 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2F004-khaki-green-s-black-image-2.webp?alt=media&token=11aa4633-35ab-41ee-8fee-23a13585ea28";
const car9 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2F007-hw-phev-turquoise-green-pearl-white-roof-2.webp?alt=media&token=b4742447-61e1-4764-88c5-2cd2d71383a3";

const carData = [
  {
    id: 1,
    image: car1,
    smallhead: "DESIGNED TO SURPRISE",
    headings: "MG HECTOR",
    price: "₹11.99* LAKH",
    features: "I-swipe touch gesture controls",
    testDriveLink: "Hector",
    modelType: "Hector",
  },
  {
    id: 8,
    image: car8,
    smallhead: "DRIVE THE FUTURE",
    headings: "HECTOR TOMAHAWK EV",
    price: "₹13.99 LAKH* + 4.90/km*",
    features: "",
    testDriveLink: "HectorTomahawkEv",
    modelType: "Hector Tomahawk EV",
  },
  {
    id: 9,
    image: car9,
    smallhead: "DRIVE THE FUTURE",
    headings: "HECTOR TOMAHAWK PHEV",
    price: "₹21.79 LAKH* + 3.20/km*",
    features: "",
    testDriveLink: "HectorTomahawkPhev",
    modelType: "Hector Tomahawk PHEV",
  },
  {
    id: 2,
    image: car2,
    smallhead: "DRIVE UNSTOPPABLE",
    headings: "MG GLOSTER",
    price: "₹38.33* LAKH",
    features: "4x4, 7 Terrain",
    testDriveLink: "Gloster",
    modelType: "Gloster",
  },
  {
    id: 3,
    image: car3,
    smallhead: "THE STREET SMART CAR",
    headings: "MG COMET EV",
    price: "₹4.99 LAKH* + 3.1/km*",
    features: "Floating Twin Display",
    testDriveLink: "Comet",
    modelType: "Comet Ev",
  },
  {
    id: 4,
    image: car4,
    smallhead: "THE MOST ADVANCED SUV",
    headings: "MG ASTOR",
    price: "₹9.65* LAKH",
    features: "ADAS L2",
    testDriveLink: "Astor",
    modelType: "Astor",
  },
  {
    id: 5,
    image: car5,
    smallhead: "EVING IS LIVING 2024",
    headings: "MG ZS EV",
    price: "₹13 LAKH* + 4.5/km*",
    features: "50.3 kWh Battery",
    testDriveLink: "ZsEv",
    modelType: "Zs EV",
  },
  {
    id: 6,
    image: car6,
    smallhead: "LIVE BUSINESS CLASS 2024",
    headings: "MG WINDSOR EV",
    price: "₹9.99* Lakh + Rs.3.9/km*",
    features: "Convenience",
    testDriveLink: "Windsor",
    modelType: "Windsor EV",
  },
  {
    id: 7,
    image: car7,
    smallhead: "PREPARE FOR DOMINANCE",
    headings: "MG Majestor",
    price: "",
    features: "",
    testDriveLink: "majestor",
    modelType: "majestor",
  },
];

const ResponsiveCarousel = ({ autoSlide, autoSlideInterval, props }) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [openTestDrive, setOpenTestDrive] = useState(false);
  const [address, setAddress] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [modelType, setModelType] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = slickCSS;
    document.head.appendChild(style);

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      style.remove();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getCenterPadding = () => {
 if (windowWidth >= 1440) return "28%";
if (windowWidth >= 1024) return "24%";
if (windowWidth >= 768) return "18%";
if (windowWidth >= 480) return "10%";
return "5%";
  };

  // Height of the background section ONLY (without car overflow)
  const getBgHeight = () => {
    if (windowWidth >= 2560) return "520px";
    if (windowWidth >= 1440) return "380px";
    if (windowWidth >= 1024) return "310px";
    if (windowWidth >= 768) return "250px";
    if (windowWidth >= 480) return "185px";
    return "150px";
  };

  // How much the car image dips below bg into the white section
  const getCarOverflow = () => {
    if (windowWidth >= 1440) return "130px";
    if (windowWidth >= 1024) return "110px";
    if (windowWidth >= 768) return "85px";
    if (windowWidth >= 480) return "65px";
    return "50px";
  };

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: getCenterPadding(),
    swipeToSlide: true,
    pauseOnHover: false,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const handlePrev = () => sliderRef.current?.slickPrev();
  const handleNext = () => sliderRef.current?.slickNext();

  const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const validateMobile = (v) => /^\+?\d{10,14}$/.test(v);

  const handleSubmit = (event) => {
    event.preventDefault();
    let valid = true;
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      valid = false;
    } else setEmailError("");
    if (!validateMobile(mobile)) {
      setMobileError("Please enter a valid mobile number");
      valid = false;
    } else setMobileError("");
    if (valid) {
      props?.BookTestDrive(name, email, mobile, modelType, dateTime, address);
      setName(""); setEmail(""); setMobile(""); setModelType(""); setDateTime(""); setAddress("");
    }
  };

  const bgHeight = getBgHeight();
  const carOverflow = getCarOverflow();
  // Car slider total height spans bg + the overflow into white section
  const carTotalHeight = `calc(${bgHeight} + ${carOverflow})`;

  return (
    <>
      {/* ══════════════════════════════════════════
          MAIN BANNER WRAPPER
          position: relative — car slider floats over bg + white strip
      ══════════════════════════════════════════ */}
      <Box sx={{ width: "100%", position: "relative", backgroundColor: "#fff",  }}>

        {/* ── BACKGROUND IMAGE SECTION ── */}
        <Box
          sx={{
            width: "100%",
            height: bgHeight,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          {/* Left Arrow */}
          <Button
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: { xs: "6px", sm: "12px", md: "20px" },
              top: "120%",
              transform: "translateY(-50%)",
              zIndex: 20,
              minWidth: "auto",
              width: { xs: 30, sm: 36, md: 34 },
              height: { xs: 30, sm: 36, md: 34 },
              borderRadius: "6px",
              backgroundColor: "#D62E31",
              color: "#fff",
              p: 0,
              "&:hover": { backgroundColor: "#a01f20" },
            }}
          >
            <ArrowBackIosIcon sx={{ fontSize: { xs: 13, sm: 16, md: 18 }, ml: "3px" }} />
          </Button>

          {/* Right Arrow */}
          <Button
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: { xs: "6px", sm: "12px", md: "20px" },
              top: "120%",
              transform: "translateY(-50%)",
              zIndex: 20,
              minWidth: "auto",
              width: { xs: 30, sm: 36, md: 34 },
              height: { xs: 30, sm: 36, md: 34 },
              borderRadius: "6px",
              backgroundColor: "#D62E31",
              color: "#fff",
              p: 0,
              "&:hover": { backgroundColor: "#a01f20" },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: { xs: 13, sm: 16, md: 18 } }} />
          </Button>
        </Box>

        {/* ── CAR IMAGE SLIDER ──
            Absolutely positioned from top of the component.
            Height = bgHeight + carOverflow so the bottom of the car
            dips into the white section below the bg image.
            zIndex 10 = above bg and white strip.
            pointerEvents none = clicks pass through to arrows/buttons.
        ── */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: carTotalHeight,
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          <Slider ref={sliderRef} {...sliderSettings}>
            {carData.map((car) => (
              <Box
                key={car.id}
                sx={{
                  height: carTotalHeight,
                  display: "flex !important",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  outline: "none",
                  px: { xs: "4px", sm: "6px", md: "8px" },
                }}
              >
                <img
                  src={car.image}
                  alt={car.headings}
                  style={{
                    width: "80%",
                    height: "80%",
                    objectFit: "contain",
                    objectPosition: "center bottom",
                    display: "block",
                    userSelect: "none",
                    pointerEvents: "none",
                    filter: "drop-shadow(0px 8px 20px rgba(0,0,0,0.15))",
                  }}
                />
              </Box>
            ))}
          </Slider>
        </Box>

        {/* ── WHITE TEXT STRIP ──
            paddingTop accounts for car overflow so text appears
            just below where the car image ends.
        ── */}
        <Box
          sx={{
            backgroundColor: "#fff",
            width: "100%",
            textAlign: "center",
            pt: `calc(${carOverflow} + 12px)`,
            pb: { xs: 0.75, sm: 1.25 },
            px: { xs: 2, sm: 4, md: 8 },
          }}
        >
          {/* Subheading */}
          <Typography
            sx={{
              fontSize: { xs: "9px", sm: "10px", md: "11px" },
              letterSpacing: { xs: "1.5px", md: "2.5px" },
              color: "#888",
              fontWeight: 400,
              mb: { xs: "2px", md: "4px" },
              textTransform: "uppercase",
            }}
          >
            {carData[currentSlide]?.smallhead}
          </Typography>

          {/* Car Name */}
          <Typography
            sx={{
              fontSize: { xs: "17px", sm: "22px", md: "28px", lg: "32px" },
              fontWeight: 700,
              color: "#111",
              letterSpacing: "0.5px",
              mb: { xs: 0.75, md: 1.25 },
              lineHeight: 1.15,
              transition: "all 0.3s ease",
            }}
          >
            {carData[currentSlide]?.headings}
          </Typography>

          {/* Price + Features */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: { xs: "20px", sm: "36px", md: "56px" },
              mb: { xs: 1.25, md: 1.75 },
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "8px", sm: "10px", md: "11px" },
                  color: "#aaa",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  mb: "2px",
                }}
              >
                STARTS AT
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "15px", md: "18px" },
                  fontWeight: 700,
                  color: "#111",
                }}
              >
                {carData[currentSlide]?.price}
              </Typography>
            </Box>

            {/* vertical divider */}
            <Box
              sx={{
                width: "1px",
                backgroundColor: "#ddd",
                alignSelf: "stretch",
                my: "2px",
              }}
            />

            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "8px", sm: "10px", md: "11px" },
                  color: "#aaa",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  mb: "2px",
                }}
              >
                FEATURES
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "15px", md: "18px" },
                  fontWeight: 700,
                  color: "#111",
                }}
              >
                {carData[currentSlide]?.features}
              </Typography>
            </Box>
          </Box>

          {/* CTA Buttons — workflow completely unchanged */}
          <Box
            sx={{
              display: "flex",
              gap: { xs: "8px", sm: "12px" },
              justifyContent: "center",
              mb: { xs: 0.5, md: 1 },
            }}
          >



          </Box>
        </Box>

        {/* ── Dot Indicators ── */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            py: { xs: 0.75, md: 1 },
            backgroundColor: "#fff",
          }}
        >
          {carData.map((_, index) => (
            <Box
              key={index}
              onClick={() => sliderRef.current?.slickGoTo(index)}
              sx={{
                width: { xs: "8px", md: "10px" },
                height: { xs: "8px", md: "10px" },
                borderRadius: "50%",
                backgroundColor: index === currentSlide ? "#D62E31" : "#ccc",
                opacity: index === currentSlide ? 1 : 0.55,
                cursor: "pointer",
                transition: "background-color 0.3s",
                "&:hover": {
                  backgroundColor: index === currentSlide ? "#D62E31" : "#aaa",
                },
              }}
            />
          ))}
        </Box>
      </Box>

      {/* ══════════════════════════════════════════
          TEST DRIVE DIALOG — workflow unchanged
      ══════════════════════════════════════════ */}
      {/* <Dialog
        open={openTestDrive}
        onClose={() => setOpenTestDrive(false)}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.3)",
            backdropFilter: "blur(5px)",
          },
        }}
        PaperProps={{
          sx: { borderRadius: "4px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: { xs: 1.5, md: 2 },
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                color: "#D62E31",
                textAlign: "center",
                fontSize: { md: "40px", sm: "30px", xs: "22px" },
                fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
                fontWeight: "bolder",
              }}
            >
              Book a Test Drive
            </Typography>
          </Box>
          <Box>
            <CloseIcon
              onClick={() => setOpenTestDrive(false)}
              sx={{
                fontSize: { xs: 20, md: 24 },
                cursor: "pointer",
                "&:hover": { color: "#D62E31" },
              }}
            />
          </Box>
        </Box>

        <DialogContent sx={{ p: { xs: 2, md: 3 } }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "11px", md: "12px" },
                    textAlign: "center",
                    fontWeight: "700",
                    mb: 1,
                  }}
                >
                  Please fill in the mandatory details for booking a Test Drive.
                </Typography>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Name"
                    name="name"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Email"
                    name="email"
                    type="email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    error={!!emailError}
                    helperText={emailError}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Mobile"
                    name="Mobile"
                    type="number"
                    fullWidth
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                    error={!!mobileError}
                    helperText={mobileError}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Model Type"
                    name="Model Type"
                    type="text"
                    fullWidth
                    value={modelType}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Test Drive Date & Time"
                    name="date"
                    type="datetime-local"
                    fullWidth
                    value={dateTime}
                    onChange={(e) => setDateTime(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Address"
                    name="address"
                    type="text"
                    fullWidth
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                    required
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    mt: 2,
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: "#D23132",
                      fontWeight: "bolder",
                      fontSize: { xs: "14px", md: "16px" },
                      padding: { xs: "6px 20px", md: "8px 24px" },
                      "&:hover": { backgroundColor: "#a01f20" },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog> */}
    </>
  );
};

export default ResponsiveCarousel;